'use strict';

// HASH методов клиента для проверки с сервером
const methodsHASH = {
    'getEntitieHistoryValues': 'ouYwRY9ePmj4Q7D6IRIkFw==',
    'getEntitiesConfig': 'HKvsuqHqbnBfX2HwNoONOw==',
    'getEntitieValues': '36DvljjxEY3vw+6OEHIgPw==',
    'setEntitieValue': 'Zv2ZHhemHnfxlF1pEF3m4A==',
    'getSystemInfo': '25VrEbkNeJr/SoXHBOokJQ==',
    'startFWUpdate': 'i+4ehmGR9EBoV7xZVTcr7Q==',
    'addNewUser': 'n8xhoHdrPLd/oVM7pmxrEQ==',
    'changeUserData': 'l3tpQeCyVgZ9FYfQeBo2Ew==',
    'changeUserPassword': 'LMX+yxrpQDoXjnz9EwHUhA==',
    'checkSession': 'vHqwryFwQVSGrWUOpt6jyQ==',
    'deleteUser': 'AgbaVyhHuAPRoWHsMj3DZQ==',
    'getUserData': 'iorwg6JBkVvVK+WIVR1/BQ==',
    'getUserEvents': 'sCpED5tkHG3ntDZvRQZvZA==',
    'getUserList': 'FBJjT/vG5g7D2xVldTbyeA==',
    'login': '88yJzcJa7FjthTHiSXqVfg==',
    'logoff': '1N14LyTteTmQ00K+bJE6EA==',
    'getDashboardConfig': 'fIyFwrzhkheyX9H7j8uEYw==',
    'getDashboardsTree': '14SqGbCkLYmLC6Roq2hnaA=='
};

function stringifyWithDate(key, value) {
    if (this[key] instanceof Date) return '$DATE_AND_TIME$' + value;
    else return value;
}

function parseWithDate(key, value) {
    if (typeof value === 'string' && value.indexOf('$DATE_AND_TIME$') === 0)
        try {
            return new Date(value.slice('$DATE_AND_TIME$'.length));
        } catch (e) {
            //
        }
    return value;
}

class RPCApiError extends Error {
    constructor(errorCode, message) {
        let errorText;
        let errorData = null;
        try {
            errorData = JSON.parse(message);
            errorText = errorData.message;
        } catch {
            errorText = `Ошибка RPC Over HTML Api, код: ${errorCode} (${message || ''})`;
        }
        super(errorText);
        if (errorData) this.trace = errorData.trace;
        this.errorCode = errorCode;
    }
}

class RPCOverHTMLApi {
    constructor(serverURL) {
        // ссылка на сервр API
        this.apiURL = serverURL || '';
        // описание методов полученных с сервера
        this.serverApiDescription = [];
        // данные для проверки безопасности
        this.sessionData = '';
    }

    // выполнить метод API
    runMethod(method, ...args) {
        return new Promise((resolve, reject) => {
            const url = this.apiURL + '/api/' + method;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'session-data': this.sessionData
                },
                body: JSON.stringify(args, stringifyWithDate),
            }).then(res => {
                const { status } = res;
                if (status !== 200) {
                    res.text().then(text => reject(new RPCApiError(status, text)));
                    return;
                }
                res.text()
                .then(data => resolve(JSON.parse(data, parseWithDate)))
                .catch(err => reject(err));
            }).catch(err => reject(new RPCApiError(-1, err.message)));
        });
    }

    // инициализировать API
    connect() {
        // получить список методов сервера и проверить контрольные суммы
        return new Promise((resolve, reject) => {
            const url = this.apiURL + '/apimethods';
            fetch(url)
                .then(res => {
                    const { status } = res;
                    if (status !== 200) {
                        reject(new Error(`Status Code: ${status}`));
                        return;
                    }

                    res.json()
                        .then(data => {
                            this.serverApiDescription = [...data];
                            const res = {
                                result: true,
                                message: []
                            };
                            for (const method in methodsHASH) {
                                const apiMethod = data.find(item => item.name === method);
                                if (apiMethod) {
                                    if (methodsHASH[method] !== apiMethod.description.Hash) {
                                        res.result = false;
                                        res.message.push(`Не совпадает HASH для метода ${method}`);
                                    }
                                } else reject(new Error(`На сервере нет метода ${method}`));
                            }
                            resolve(res);
                        })
                        .catch(err => reject(err));
                })
                .catch(err => reject(err));
        });
    }

    /** 
	* Установить данные для проверки безопасности
	*/
    setSessionData(data) {
        this.sessionData = data;
    }
	
	/** 
	* Установить URL сервера
	*/
    setServerURL(serverURL) {
		this.apiURL = serverURL;        
    }

    /**
    * Отправить файл на сервер через FormData
    *
    * @param {FormData} data - данные
    * @returns {boolean}
    */
    uploadFilesToserver(data) {
        return new Promise((resolve, reject) => {
            const url = this.apiURL + '/upload';
            fetch(url, {
                method: 'POST',
                headers: {
                    'session-data': this.sessionData
                },
                body: data,
            }).then(res => {
                const { status } = res;
                if (status !== 200) {
                    res.text().then(text => reject(new RPCApiError(status, text)));
                    return;
                }
                res.text()
                .then(() => resolve(true))
                .catch(err => reject(err));
            }).catch(err => reject(new RPCApiError(-1, err.message)));
        })
    }

    /**
    * Получить значения для нескольких сущностей по массиву маскок
    *
    * @param {string} entitieId - имя сущности
    * @param {Date} momentStart - дата начала интервала выборки
    * @param {Date} momentEnd - дата окончания интервала выборки
    * @returns {Array} - массив объектов
    *   value - значение
    *   moment - дата и время
    *   status - статус
    */
    getEntitieHistoryValues(entitieId, momentStart, momentEnd) {
        return this.runMethod('getEntitieHistoryValues', entitieId, momentStart, momentEnd);
    }

    /**
    * Получить описание настроек для сущностей
    *
    * @param {Array} entitiesId - массив с именами элементов, если последний знак *,
    * @returns {Array} - массив с объектами
    *   entitieId - имя сущности
    *   type - тип
    *   mode - правила доступа
    *   description - текстовое описание
    *   archiveMode - тип архивирования
    *   onChangeScript - сценарий выполняемый при изменении данных
    */
    getEntitiesConfig(entitiesId) {
        return this.runMethod('getEntitiesConfig', entitiesId);
    }

    /**
    * Получить значения для нескольких сущностей по массиву маскок
    *
    * @param {Array} entitiesId - массив с именами элементов, если последний знак *,
    *   то вернутся значения по одноименной группе элементов
    * @param {bool} showDescription - надо ли присылать описание сущности
    * @returns {Array} - массив с даннными (объектами)
    *   entitieId - имя сущности
    *   value - значение
    *   moment - дата и время
    *   status - статус
    *   description - описание (если запрашивали)
    */
    getEntitieValues(entitiesId, showDescription) {
        return this.runMethod('getEntitieValues', entitiesId, showDescription);
    }

    /**
     * Записать значение в сущность
     *
     * @typedef {Object} NewValue
     * @property {any} value - значение
     * @property {Date} moment - дата и время
     * @property {string} status - статус
     *
     * @param {string} entitieId - имя сущности
     * @param {NewValue} data - данные
     */
    setEntitieValue(entitieId, data) {
        return this.runMethod('setEntitieValue', entitieId, data);
    }

    /**
    * Получить данные о системе и программе
    *
    * @returns {object}
    *       osType - тип операционной системы
    *       osArch
    *       freemem - свободная память
    *       totalmem - всего памяти
    *       uptame - время работы
    *       loadavg
    *       dateTime - время сервера
    *       versionFW - версия ПО
    */
    getSystemInfo() {
        return this.runMethod('getSystemInfo');
    }

    /**
    * Запустить обновение ПО
    *
    * @param {string} fileName - файл обновления
    * @returns {boolean}
    */
    startFWUpdate(fileName) {
        return this.runMethod('startFWUpdate', fileName);
    }

    /**
    * Изменить пароль пользователя
    *
    * @param {string} login - пользователь
    * @param {object} userData - данные пользователя
    *   isAdmin
    *   password
    *   displayName
    *   email
    *   photo
    *   permissions
    * @returns {boolean}
    */
    addNewUser(login, userData) {
        return this.runMethod('addNewUser', login, userData);
    }

    /**
    * Изменить данные пользователя
    *
    * @param {string} login - пользователь
    * @param {object} userData - данные пользователя
    *   isAdmin - изменить может только администратор
    *   displayName
    *   password
    *   email
    *   photo
    *   permissions
    * @returns {boolean}
    */
    changeUserData(login, userData) {
        return this.runMethod('changeUserData', login, userData);
    }

    /**
    * Изменить пароль пользователя
    *
    * @param {string} login - пользователь
    * @param {string} newPassword - новый пароль
    * @returns {boolean}
    */
    changeUserPassword(login, newPassword) {
        return this.runMethod('changeUserPassword', login, newPassword);
    }

    /**
    * Проверить существует ли сессия пользователя
    *
    * @param {string} sessionData - данные идентифицирующие сессию
    * @returns {boolean}
    */
    checkSession(sessionData) {
        return this.runMethod('checkSession', sessionData);
    }

    /**
    * Удалить пользователя
    *
    * @param {string} login - пользователь
    * @returns {boolean}
    */
    deleteUser(login) {
        return this.runMethod('deleteUser', login);
    }

    /**
    * Получить данные пользователя
    *
    * @returns {Object} - объект
    *   login
    *   isAdmin
    *   displayName
    *   email
    *   photo
    */
    getUserData() {
        return this.runMethod('getUserData');
    }

    /**
    * Получить список событий пользователей за период времени
    *
    * @param {Date} momentFrom - начальный моммент выборки
    * @param {Date} momentTo - конечный моммент выборки
    * @returns {Array} - массив объектов
    *   login
    *   moment
    *   eventCode
    *       code
    *       description
    *   description
    */
    getUserEvents(momentFrom, momentTo) {
        return this.runMethod('getUserEvents', momentFrom, momentTo);
    }

    /**
    * Получить список пользователей
    *
    * @returns {Array} - массив объектов
    *   login
    *   isAdmin
    *   displayName
    *   email
    *   photo
    *   permissions
    */
    getUserList() {
        return this.runMethod('getUserList');
    }

    /**
    * Функция входа в систему
    *
    * @param {string} login - пользователь
    * @param {string} password - пароль
    * @returns {string} - идентификатор сесиии, null означает что подключиться не удалось
    */
    login(login, password) {
        return this.runMethod('login', login, password);
    }

    /**
    * Функция выхода из системы
    *
    * @returns {boolean} - идентификатор сесиии
    */
    logoff() {
        return this.runMethod('logoff');
    }

    /**
    * Получить описание панели отображения
    *
    * @param {string} dashbodName - имя панели
    * @returns {object}
    */
    getDashboardConfig(dashbodName) {
        return this.runMethod('getDashboardConfig', dashbodName);
    }

    /**
    * Получить дерево дашбоардов
    *
    * @returns {Array} - массив объектов
    *   isFolder
    *   path
    *   key
    *   name
    *   children
    */
    getDashboardsTree() {
        return this.runMethod('getDashboardsTree');
    }
}

export default RPCOverHTMLApi
